import { render, staticRenderFns } from "./accordion-button.vue?vue&type=template&id=9ee7a6fe&scoped=true"
import script from "./accordion-button.vue?vue&type=script&lang=js"
export * from "./accordion-button.vue?vue&type=script&lang=js"
import style0 from "./accordion-button.vue?vue&type=style&index=0&id=9ee7a6fe&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "9ee7a6fe",
  null
  
)

export default component.exports